export default __webpack_public_path__ + "static/Plain-Skeleton-ad65eb402623acf8f708a4baa4dc8f68.woff";